__turbopack_context__.v({
  "my_list_videos": "MyListVideos-module-scss-module__5ft3iG__my_list_videos",
  "my_list_videos_user_prompt": "MyListVideos-module-scss-module__5ft3iG__my_list_videos_user_prompt",
});
